export default __webpack_public_path__ + "static/bar-with-labels-3637f3e136da09dd74bd1c84674271bc.png";